
import React, { useState, useEffect, useRef, Suspense } from "react";
import moment from "moment";
import {filterData} from "../../../Utils/GridService";
import "./ChangeHandling.scss"
import { useParams } from "react-router-dom";
import _, { isEmpty } from "lodash";
import { Button } from "react-bootstrap";
import PageLayout from "../../PageLayout";
import { Dialog } from "primereact/dialog";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import ACPFilter from "../../ACP/common/ACPFilter";
import { checkIfOrderSame, multiFilterChange, showToast, bufferToWork, isPOAEditableColor } from "../../../utils";
import { useSelector, useDispatch } from "react-redux";
import filter from "../../../assets/images/filter.svg";
import blueFilter from "../../../assets/images/BlueFilterIcon.svg";
import CustomizeView from "../../common/CustomizeView";
import { AcpService } from "../../../service/ACPService";
import ChangeHandlingHeader from "./ChangeHandlingHeader";
import ChangeHandlingHistoryHeader from "./ChangeHandlingHistoryHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { extractData } from "../../Projects/ProjectPlan/util";
import { ProjectService } from "../../../service/PegaService";
import { DataTable } from "primereact/datatable";
import { AcpCommonService } from "../../../service/AcpCommonService";
import { SortAndFilterService } from "../../../service/SortAndFilterService";
import { getChangeHandlingData as fetchChangeHandlingData } from "../../../apis/ChangeHandlingApi";
import LoadingOverlay from "react-loading-overlay-ts";
import { UnsavedChangesDialog } from "../../common/NavigationPrompt";
import { getColumnsOrder, setColumnsOrder } from "../../../apis/commonApi";
import UnAuthorizedComponent from "../../UnAuthorized/UnAuthorizedComponent";
import { isRoleMatch} from "../../../utils";
import { refreshPOA } from '../../../apis/ChangeHandlingApi';
import { getHistoryData } from '../../../apis/ChangeHandlingApi';
import ChangeHandlingFilter from "./ChangeHandlingFilter";
import ChangeHandlingHistoryFilter from './ChangeHandlingHistoryFilter';
import TableFooter from './TableFooter';
import Footer from "../../common/tableFooter/tableFooter";
import FooterButtons from "../../AWMJobs/DesignJobs/FooterButtons";
import { cicImage, changeHandlingExportCSVFlags, cicOptions } from "./utils";

const FullKitConditionPopUp = React.lazy(() => import("./FullKitConditionPopUp"));

const ConfirmationPopUp = React.lazy(() => import("./ConfirmationPopUp"));

// Define a mapping for all response fields to user-friendly names (make available globally in this file)
const fieldDisplayNames = {
  FAAssemblyState: 'FA Assembly State',
  RTAUpdate :'RTA Update',
  ArtworkUsage: 'Artwork Usage',
  DSBP_Initiative_Name: 'DSBP Initiative Name',
  ImpactingFA: 'Impacting FA',
  DateDetected: 'Date Detected',
  AWMCICStatus: 'AWM CIC Status',
  DSBP_PMP_PIMaterialNumber: 'DSBP PMP PI Material Number',
  OldValue: 'Old Value',
  ImpactingCIC: 'Impacting CIC',
  AcceptedBy: 'Accepted By',
  DSBP_PMP_PIMaterialID: 'DSBP PMP PI Material ID',
  ImpactingPOA: 'Impacting POA',
  Field: 'Field',
  RTA_Project_Name: 'RTA Project Name',
  IsPOAEditable: 'Is POA Editable',
  ArtworkPackage: 'Artwork Package',
  DateCompleted: 'Date Completed',
  POAOwner: 'POA Owner',
  ID: 'ID',
  DSBP_PMP_PIMaterialDescription: 'DSBP PMP PI Material Description',
  BufferToWorkRatio: 'Buffer To Work Ratio',
  RTA_POADescription: 'RTA POA Description',
  Status: 'Status',
  StatusOfChange: 'Status of Change',
  RTA_ProjectID: 'RTA Project ID',
  WCCICStatus: 'WC CIC Status',
  DSBP_InitiativeID: 'DSBP Initiative ID',
  RTA_POANumber: 'RTA POA Number',
  POAStatus: 'POA Status',
  DSBP_PMP_packageLevel: 'DSBP PMP Package Level',
  NewValue: 'New Value',
  ActivePOAMatrix: 'Active POA Matrix',
  CICDetailsPage: 'CIC Details Page',
  ErrorMessage: 'Error Message',
};

const stateValues = {
  enableFilter: false,
  selectedColumn: "",
  projectFrozen: false,
  selectedFields: {},
  sortData: [],
  filters: [],
  frozenColumns: [],
  columnWiseSelectedFields: [],
  selectedColumnName: null,
  breadCrumbs: [],
  cicCommentList: {},
  cicHeader: "",
  visible: false,
  showSelctionPopUp: false,
  tableHeight: "60vh",
  projectState: "",
  checkReadWriteAccess:false,
  urlAccessable:""
};

const showTableColumns = {
  RTA_POANumber: "POA #",
  Field: "Field",
  OldValue: "Old Value",
  NewValue: "New Value",
  RTAUpdate: "RTA Update",
  IsPOAEditable: "POA Editable?",
  ActivePOAMatrix: 'Active Copy Matrix',
  POAStatus: "POA Status",
  ImpactingCIC: "Impacting CIC",
  AWMCICStatus: "AWM CIC Status",
  ImpactingFA: "Impacting FA",
  FAAssemblyState: "FA Assembly State",
  BufferToWorkRatio: "B:W",
  StatusOfChange: "Status of Change",
  ErrorMessage: "Error Message",
  AcceptedBy: "Accepted By",
  DateCompleted: "Date Completed"
};

// Wrapper component to ensure Router context is available
const ChangeHandlingWrapper = () => {
  const [isRouterReady, setIsRouterReady] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsRouterReady(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  if (!isRouterReady) {
    return <div>Loading...</div>;
  }
  
  return <ChangeHandlingComponent />;
};

const ChangeHandlingComponent = () =>{
  const op = useRef(null);
  const toast = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { ProjectID } = useParams();
  const safeNavigate = navigate || (() => console.warn('Navigate not available'));
  const safeLocation = location || { pathname: '', search: '' };
  const safeProjectID = ProjectID || null;
  
  // Custom date formatting function for Change Handling dates
  const formatDateWithMonthName = (dateValue) => {
    if (!dateValue) return dateValue;
    
    try {
      // Handle YYYYMMDD format (like "20250716")
      if (/^\d{8}$/.test(dateValue)) {
        const momentDate = moment(dateValue, "YYYYMMDD");
        if (momentDate.isValid()) {
          return momentDate.format('DD-MMM-YY');
        }
      }
      
    } catch (error) {
      return dateValue;
    }
  };

  const dispatch = useDispatch();
  const filterArray = useRef([]);
  const colAllSelected = useRef([]);
  const selectedFieldsRef = useRef([]);
  const selectedColumnList = useRef([]);
  const [filters, setFilters] = useState([]);
  const [sortData, setSortData] = useState([]);
  const [sortHistoryData, setSortHistoryData] = useState([]);
  const [pegadata, setPegadata] = useState([]);
  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [state, setState] = useState(stateValues);
  const [isSearch, isSearchSet] = useState(false);
  const [isHistorySearch, setIsHistorySearch] = useState(false);
  const [frozenWidth, setFrozenWidth] = useState("40px");
  const [frozenColumns, setFrozenColumn] = useState([]);
  const [fieldUpdated, setFieldUpdated] = useState(false);
  const [allColumnNames, setAllColumnNames] = useState([]);
  const [availableFields, setAvailableFields] = useState([]);
  const [customViewIsAddedMyProject, isCustomViewIsAddedMyProject] = useState(false);
  const [selectedFields, setSelectedFields] = useState({});
  const [projectColumnName, setProjectColumnNames] = useState([]);
  const [InitialTableData, setInitialTableData] = useState([]);
  const [allSelectedColumns, setAllSelectedColumns] = useState([]);
  const [customizeViewFields, setCustomizeViewFields] = useState();
  const [selectedColumnName, setSelectedColumnName] = useState(null);
  const [isGlobalFilterActivated, setGlobalFilterActivated] = useState(false)
  const [openFullKitpopUp, setOpenFullkitPopUp] = useState(false);
  const [rowFullkitData, setRowFullkitData] = useState(null);
  const [fieldName, setFieldName] = useState('');
  const [changeHandlingData, setChangeHandlingData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [items, setItems] = useState([]);
  const [flatPegadata, setFlatPegadata] = useState([]);
  const [checkboxSelected, setCheckboxSelected] = useState([]);
  const [checkboxSelectedAll, setCheckboxSelectedAll] = useState(false);
  const [showConfirmationPopUp, setShowConfirmationPopUp] = useState(false);
  const [confirmationPopUpData, setShowConfirmationPopUpData] = useState([]);
  const [accessType, setAccessType] = useState("");
  const [resetKey, setResetKey] = useState(0);
  const [pageEdited, setPageEdited] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [isSpecialProject, setIsSpecialProject] = useState(false);
  const allColumnsData = useSelector((state) => state?.DropDownValuesReducer?.DropDownValuesData?.ArtworkAgilityChangeHandling);
  const [initialSearchFilters, setInitialSearchFilters] = useState({});
  const [datatableColumnFromPega, setDatatableColumnFromPega] = useState([]);
  const [pgDefaultColumns, setPGDefaultColumns] = useState({});
  const [historyData, setHistoryData] = useState([]);
  const [showHistoryDialog, setShowHistoryDialog] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyLoadingRow, setHistoryLoadingRow] = useState(null);
  const [historyFilters, setHistoryFilters] = useState({});
  const [historySelectedColumn, setHistorySelectedColumn] = useState(null);
  const [filteredHistoryData, setFilteredHistoryData] = useState([]);
  const historyOp = useRef(null);
  const userId = localStorage.getItem("userId");
  const StorageData = localStorage.getItem("customizeViewFieldsChangeHandling");
  const customizeViewFieldsStorage = StorageData && JSON.parse(StorageData);
  const [refreshPOLoading, setRefreshPOLoading] = useState(false);
  
  const {
    userDetails: { UserGroup, AccessGroup },
  } = useSelector((state) => state?.UserDetailsReducer);

  const { userInformation } = useSelector((state) => state.UserReducer);

const {checkReadWriteAccess,urlAccessable}=state;
  const [chwrapFreeText, setchWrapFreeText] = useState(() => {
    const saved = sessionStorage.getItem("chwrapFreeText");
        return saved === "true";
  });
  
useEffect(() => {
  sessionStorage.setItem("chwrapFreeText", chwrapFreeText);
}, [chwrapFreeText]);
  const [historywrapFreeText, setHistoryWrapFreeText] = useState(() => {
    const saved = sessionStorage.getItem("historywrapFreeText");
    return saved === "true";
  });

useEffect(() => {
  sessionStorage.setItem("historywrapFreeText", historywrapFreeText);
 }, [historywrapFreeText]);

  // all checkbox functionality implemented
  useEffect(() => {
    items?.length === checkboxSelected?.length
      ? setCheckboxSelectedAll(true)
      : setCheckboxSelectedAll(false);
  }, [checkboxSelected, items]);

 // 3109 security matrix
  useEffect(() => {
    const isUserAccess = isRoleMatch(AccessGroup, [
      "CapacityManager",
      "ProjectManager",
      "TaskOwner",
    ]);
    updateStateValue('checkReadWriteAccess', isUserAccess);
      setLoader(false);
  }, [AccessGroup]);

  useEffect(()=>{
    if(urlAccessable==="Hidden"){
      updateStateValue('checkReadWriteAccess', false);
    }else if(urlAccessable === "Read"){
      updateStateValue('checkReadWriteAccess', true);
    }else if(urlAccessable === "Write"){
      updateStateValue('checkReadWriteAccess', true);
    }
  },[state.urlAccessable])

  // Get navigation state data passed from DependencyMappingList
  const navigationState = location.state || {};
  const pmpIdFromState = navigationState.PIMaterialID;

  let userAccessPayLoad = {
    ArtworkAgilityPage: {
      UserId: userInformation?.userid,
      UserGroup: UserGroup,
      AWMProjectID: safeProjectID,
      DSBP_PMP_PIMaterialID: pmpIdFromState,
    },
  };
  const getChangeHandlingData = async (showAllRecords = false) => {
    setLoader(true);

    if(showAllRecords){
      userAccessPayLoad = {
        ArtworkAgilityPage: {
          UserId: userInformation?.userid,
          UserGroup: UserGroup,
          AWMProjectID: safeProjectID,
          DSBP_PMP_PIMaterialID: null,
        },
      };
    }

    try {
      const response = await fetchChangeHandlingData(userAccessPayLoad);
      const apiData = response?.PMPAttributeList || response?.data?.PMPAttributeList;
      setAccessType(response?.AccessType)
      updateStateValue('urlAccessable', response?.AccessType);
      updateStateValue('projectState', response?.projectState || response?.data?.projectState);
      
      setItems([]);
      setFlatPegadata([]);
      setAllSelectedColumns([]);
      setDatatableColumnFromPega([]);
      
      if (apiData?.length) {
        const wrappedData = apiData.map(row => ({ data: row }));
        // Sort by BufferToWorkRatio in descending order (highest first)
        const sortedData = wrappedData.sort((a, b) => {
          const aVal = parseFloat(a.data?.BufferToWorkRatio) || parseFloat(a.data?.Buffer_To_Work) || 0;
          const bVal = parseFloat(b.data?.BufferToWorkRatio) || parseFloat(b.data?.Buffer_To_Work) || 0;
          return aVal - bVal; // ascending
        });
        setChangeHandlingData(sortedData);
        setItems(sortedData);
        const dynamicColumns = Object.keys(showTableColumns).map(key => ({
          field_Name: key,
          Column_Name: showTableColumns[key] || key
        }));
        setAllSelectedColumns(dynamicColumns);
        setDatatableColumnFromPega(dynamicColumns);
        const flatPegadata = apiData?.flatMap((obj) => extractData(obj));
        setFlatPegadata(flatPegadata);
      }
    } catch (error) {
      setItems([]);
      setFlatPegadata([]);
      setAllSelectedColumns([]);
      setDatatableColumnFromPega([]);
    } finally {
      setLoader(false);
    }
  };
  const handleShowAll = () => {
    if (UserGroup?.length && userInformation?.userid ) {
      getChangeHandlingData(true);
    }
  }

  useEffect(() => { 
    if (UserGroup?.length && userInformation?.userid && state.checkReadWriteAccess) {
      getChangeHandlingData();
    }
  }, [state.checkReadWriteAccess,UserGroup,userInformation,safeProjectID,pmpIdFromState]);

  useEffect(() => {
    let allCol = allColumnsData?.map((item) => item.Field_Name) || [];
    setAllColumnNames(allCol);
    let columnWidthMyProject = {};
    if (allCol.length) {
      allCol.forEach((column) => {
        columnWidthMyProject[column] = 100;
      });
    }

    let getJsonStoredWidthColumns = localStorage.getItem("columnWidthASAChangeHandling");
    let getStoredWidthColumns = JSON.parse(getJsonStoredWidthColumns);
    const checkEmptyObject = _.isEmpty(getStoredWidthColumns);

    if (checkEmptyObject) {
      localStorage.setItem("columnWidthASAChangeHandling", JSON.stringify(columnWidthMyProject));
    }
    let availableFields;
    const selectedFeilds = Object.keys(showTableColumns);
    availableFields = allCol?.filter(function (objFromA) {
      return !selectedFeilds.find(function (objFromB) {
        return objFromA === objFromB;
      });
    });

    const selectedFeildsVal = Object.keys(showTableColumns);
    const customizeViewFieldsUpdated = formCustomizeObject(
      availableFields,
      [],
      selectedFeildsVal
    );
    setPGDefaultColumns(customizeViewFieldsUpdated)
  }, []);

  useEffect(() => {
    if (userInformation?.userid != undefined) setToInitialCustomizeView();

    getCustomizedView();
  }, [allColumnNames, userInformation, StorageData, showTableColumns]);

  useEffect(() => {
    const fetchColumnName = async () => {
      const dataFromPegaRes = await getColumnsOrder(userId, "ChangeHandlingAllColumnNames", "NA", "NA");
      if (dataFromPegaRes != null && dataFromPegaRes?.length > 0) {
        // setAllSelectedColumns(dataFromPegaRes);
        setDatatableColumnFromPega(dataFromPegaRes);
      } else {
        let localAllColumns = localStorage.getItem("ChangeHandlingASAallColumnNames");
        let _allColumns = JSON.parse(localAllColumns);
        if (isEmpty(_allColumns)) {
          _allColumns = ProjectService.getASAChangeHandlingTableColumns();
        }
        setAllSelectedColumns(_allColumns);
      }
    };
    if (userInformation?.userid != undefined) fetchColumnName();
  }, [userInformation]);

  // Construct proper artwork alignment URL based on current path
  const getArtworkAlignmentUrl = () => { 
    // Check if user came from dependency mapping or artwork status via navigation state
    const fromDependencyMapping = navigationState.from === "dependencyMappingPage";
    const fromArtworkStatus = navigationState.from === "artworkstatusPage";
    const fromArtworkAlignment = navigationState.from === "artworkalignmentpage";
    
    if ((fromDependencyMapping || fromArtworkStatus || fromArtworkAlignment) && navigationState.previousUrl) {
      // Use the exact URL they came from
      return navigationState.previousUrl;
    }
    
    const currentPath = safeLocation.pathname; 
    if (currentPath.includes("/DSBP/tab/artworkAlignment/ChangeHandling/")) {
      return currentPath.replace(/\/ChangeHandling\/[^\/]+/, "");
    }
    
    if (currentPath.includes("/artworkAlignment/ChangeHandling/")) {
      return currentPath.replace("/ChangeHandling", "");
    }
    
    if (currentPath.includes("/DSBP/tab/dependencyMapping/ChangeHandling/")) {
      return currentPath.replace("/ChangeHandling", "");
    }

    const segments = currentPath.split("/");
    segments.pop();
    return segments.join("/");
  };
  
  const projectPlanUrl = getArtworkAlignmentUrl();
  //Keeping this useEffect too make table data filterable and set table data on initilize
  useEffect(() => {
    if (
      _.isEmpty(state.selectedFields) ||
      Object.values(state.selectedFields)?.every((ele) => ele.length === 0)
    ) {
      setTableData(items);
    } else {
      const filteredData = filterData(items, state.selectedFields);
      setTableData(filteredData);
    }
  }, [state.selectedFields, items]);

  useEffect(()=>{
    if (items?.length) {
      setInitialTableData(_.cloneDeep(items));
    }
  },[items])

  const setToInitialCustomizeView = async () => {
    let availableFields;
    const allColumnNamesConstValue = Object.keys(showTableColumns);
    availableFields = allColumnNames?.filter(function (objFromA) {
      return !allColumnNamesConstValue?.find(function (objFromB) {
        return objFromA === objFromB;
      });
    });
    let customizeViewColumnFromPega = await getColumnsOrder(
      userInformation?.userid,
      "customizeViewFieldsChangeHandling",
      "NA",
      "NA"
    );
    if (customizeViewColumnFromPega != null && customizeViewColumnFromPega != "") {
      setCustomizeViewFields(customizeViewColumnFromPega);
      getAvailableFields(customizeViewColumnFromPega);
      localStorage.setItem(
        "customizeViewFieldsChangeHandling",
        JSON.stringify(customizeViewColumnFromPega)
      );
    } else {
      const customizeViewFieldsUpdated = formCustomizeObject(
        availableFields,
        [],
        Object.keys(showTableColumns)
      );
      setCustomizeViewFields(customizeViewFieldsUpdated);
      localStorage.setItem(
        "customizeViewFieldsChangeHandling",
        JSON.stringify(customizeViewFieldsUpdated)
      );
      await setColumnsOrder(
        userInformation?.userid,
        "customizeViewFieldsChangeHandling",
        "NA",
        "NA",
        false,
        JSON.stringify(customizeViewFieldsUpdated)
      );
    }
  };
const getCustomizedView = (isFrozen) => {
    const selectedData = customizeViewFieldsStorage?.selectedFields?.fieldsData;
    const freezedData = customizeViewFieldsStorage?.freezedColumns?.fieldsData;
    const availableData = customizeViewFieldsStorage?.availableFields?.fieldsData;
    let availableFields;
    if (availableData?.length) {
      availableFields = availableData;
    } else {
      let updatedColumnFinal = allColumnNames?.filter(function (objFromA) {
        return !projectColumnName.find(function (objFromB) {
          return objFromA === objFromB;
        });
      });
      const intermidaiteColumn = AcpService?.removeCommonValues(
        updatedColumnFinal,
        freezedData?.length ? freezedData : frozenColumns
      );
      const availableColumnToSelect = AcpService?.removeCommonValues(
        intermidaiteColumn,
        selectedData?.length ? selectedData : projectColumnName
      );
      availableFields = availableColumnToSelect?.length
        ? availableColumnToSelect
        : updatedColumnFinal;
    }

    const freezedColumns = isFrozen
      ? frozenColumns
      : freezedData?.length
      ? freezedData
      : frozenColumns;

    let selectedFields = Object.keys(showTableColumns);
    selectedFields = AcpService?.removeCommonValues(selectedFields, freezedColumns);

    const customizeViewFieldsUpdated = formCustomizeObject(
      availableFields,
      freezedColumns,
      selectedFields
    );

    const column = AcpService?.removeCommonValues(
      selectedFields,
      freezedData?.length ? freezedData : frozenColumns
    );
    const projectColumnNamesUpdated =
      freezedColumns.length > 0 ? [...freezedColumns, ...column] : selectedFields;
    setProjectColumnNames(projectColumnNamesUpdated);
    if (!isFrozen) {
      setFrozenColumn(freezedColumns);
      setCustomizeViewFields(customizeViewFieldsUpdated);
    }
    return customizeViewFieldsUpdated;
  };


  useEffect(() => {
    frozenColumn(getCustomizeViewLocalStorage());
  }, [frozenColumns]);

  useEffect(() => {
    handleGlobalFilter();
  }, [allSelectedColumns]);

  const handleChildClick = (isClicked) => {
    if (!isClicked) {
      onClickClearFilter();
      isSearchSet(false);
      if(isSearch){
        setResetKey((prev)=>prev + 1);
      }
    }
  };

  const handleGlobalFilter = () => {
    const GlobalFilter =
      (state.columnWiseSelectedFields && state.columnWiseSelectedFields.length !== 0) || isSearch || filters?.length !== 0;
    setGlobalFilterActivated(GlobalFilter);
  };

  const getCustomizeViewLocalStorage = () => {
    const StorageData = localStorage.getItem("customizeViewFieldsChangeHandling");
    const customizeViewFieldsStorage = StorageData && JSON.parse(StorageData);
    return customizeViewFieldsStorage;
  };
  const frozenColumn = (customizeViewFieldsStorage) => {
    let totalFrozenWidth = 0;

    if (
      customizeViewFieldsStorage !== undefined &&
      customizeViewFieldsStorage !== null &&
      customizeViewFieldsStorage?.length !== 0
    ) {
      const freezedData = customizeViewFieldsStorage?.freezedColumns?.fieldsData || [];

      freezedData.forEach((field) => {
        totalFrozenWidth += field === "Task" ? 280 : 150;
      });
    }

    if (totalFrozenWidth > 0) {
      setFrozenWidth(`${totalFrozenWidth}px`);
    } else {
      setFrozenWidth(`40px`);
    }
  };


  const onSearchClick = () => {
    isSearchSet(!isSearch);
  };
  // --- search handler for history dialog ---
  const onHistorySearchClick = () => {
    setIsHistorySearch((prev) => !prev);
  };

  const renderHeader = () => {
    return (
      <div className="flex align-items-center">
        <input
          type="checkbox"
          checked={checkboxSelectedAll}
          disabled={false}
          onChange={() => {
            if(items?.length === checkboxSelected?.length) {
              setCheckboxSelected([])
            } else {
              setCheckboxSelected(items.map(ele => ele.data.IsEnabled && ele?.data?.ID))
            }
          }}
        />
      </div>
    );
  };

  const dynamicColumns = () => {
    const localColumnWidth = localStorage.getItem("columnWidthASAChangeHandling");
    let columnWidth = {};
    if (localColumnWidth) {
      columnWidth = JSON.parse(localColumnWidth);
    }
    const columnWidthKeys = Object.keys(columnWidth);
    // Checkbox column implementation
    const checkboxColumn = (
      <Column
        key="select-checkbox"
        body={(rowData) => {
          if (!rowData || !rowData.data || typeof rowData.data !== 'object') {
            return null;
          }
          const id = rowData?.data?.ID;
          return (
            <input
              type="checkbox"
              name={`select-checkbox-${id}`}
              id={`select-checkbox-${id}`}
              checked={checkboxSelected.some(ele => ele === id)}
              disabled={accessType === "Write" && !rowData.data.IsEnabled}
              onChange={() => {
                if(checkboxSelected.includes(id)) {
                  setCheckboxSelected(prevState => prevState.filter(ele => ele !== id))
                } else {
                  rowData.data.IsEnabled && setCheckboxSelected(prevState => ([...prevState, id]))
                }
              }}
            />
          );
        }}
        header={() => renderHeader()}
        frozen={true}
        className="checkbox-col change-handling-checkbox-col"
      />
    );

    // Always show both frozen and selected columns, in the correct order, no duplicates
    let frozenFields = Array.isArray(frozenColumns) ? frozenColumns : [];
    let selectedFieldsArr = (customizeViewFields && customizeViewFields.selectedFields && customizeViewFields.selectedFields.fieldsData)
      ? customizeViewFields.selectedFields.fieldsData
      : [];
    // Remove any frozen fields from selectedFieldsArr to avoid duplicates
    selectedFieldsArr = selectedFieldsArr.filter(f => !frozenFields.includes(f));
    // Combine frozen and selected fields for display order
    const orderedFields = [...frozenFields, ...selectedFieldsArr];
    // If nothing customized, fallback to all columns
    const fallbackFields = Object.keys(showTableColumns);
    const finalFields = orderedFields.length > 0 ? orderedFields : fallbackFields;
    // Map to column objects
    let displayColumns = finalFields
      .map((f) => allColumnsData?.find((ele) => ele.Field_Name === f))
      .filter(Boolean);

    if (displayColumns && displayColumns?.length) {
      return [checkboxColumn, ...displayColumns?.map((ele, i) => {
        if (ele?.Field_Name === "DSBP_PMP_PIMaterialNumber") {
          return (
            <Column
              key={ele?.Field_Name}
              field={ele?.Field_Name}
              filterField={ele?.Field_Name}
              filterMatchMode="contains"
              filter={isSearch}
              filterPlaceholder={ele?.Field_Name}
              header={columnHeader(ele?.Field_Name, ele?.Field_Name, ele)}
              columnKey={ele?.Field_Name || i}
              frozen={frozenColumns.includes(ele.Field_Name)}
              body={rowData => {
                const rawValue = rowData && rowData.data && typeof rowData.data[ele?.Field_Name] !== 'undefined' ? rowData.data[ele?.Field_Name] : '';
                // Ensure value is renderable - convert objects to strings
                const value = (typeof rawValue === 'object' && rawValue !== null) 
                  ? JSON.stringify(rawValue) 
                  : (rawValue ?? '');
                const hasHistory = rowData && rowData.data && rowData.data.HasHistory;
                const materialId = rowData?.data?.DSBP_PMP_PIMaterialID;
                
                // Handler for + sign click
                const onPlusClick = async (e) => { 
                  e.stopPropagation();
                  if (historyLoadingRow === materialId) return;
                  setHistoryLoadingRow(materialId);
                  setHistoryLoading(true);
                  try { 
                    const result = await getHistoryData(getHistoryPayload(rowData.data, ele.Field_Name));
                    let data = result;
                    
                    // Use the same response processing logic as handleGetHistoryData
                    if (result?.data && Array.isArray(result.data)) {
                      data = result.data;
                    } else if (result?.data && Array.isArray(result.data.history)) {
                      data = result.data.history;
                    } else if (Array.isArray(result?.history)) {
                      data = result.history;
                    } else if (Array.isArray(result)) {
                      data = result;
                    } else if (result && typeof result === 'object') {
                      // Try to find the first array property in the object
                      const arrKey = Object.keys(result).find(k => Array.isArray(result[k]));
                      if (arrKey) {
                        data = result[arrKey];
                      } else {
                        data = [];
                      }
                    } else {
                      data = [];
                    }
                    if (!Array.isArray(data)) data = [];
                    setHistoryData(data);
                    setShowHistoryDialog(true);
                  } catch (err) {
                    setHistoryData([]);
                    setShowHistoryDialog(true);
                  } finally {
                    setHistoryLoading(false);
                    setHistoryLoadingRow(null);
                  }
                };
                const isRowLoading = historyLoading && historyLoadingRow === materialId;
                return (
                  <span className="history-row">
                    {hasHistory && (
                      <i
                        className="pi pi-plus plus-icon"
                        style={{
                          cursor: isRowLoading ? "not-allowed" : "pointer",
                        }}
                        onClick={onPlusClick}
                      />
                    )}
                    {value}
                  </span>
                );
              }}
              className={
               ele?.freeze
                  ? "fontBoldcolor"
                  : "cursorMove non-task-width"
              }
              showFilterMenu={false}
              style={{
                whiteSpace: chwrapFreeText ? 'normal' : 'nowrap',
                wordBreak: chwrapFreeText ? 'break-word': 'unset',
                overflow: chwrapFreeText ? 'unset' : 'hidden',
                textOverflow: chwrapFreeText ? 'unset' : 'ellipsis', 
              }}
            />
          );
        }
        if (ele?.Field_Name === "WCCICStatus") {
          return (
            <Column
              key={ele?.Field_Name}
              field={ele?.Field_Name}
              filterField={ele?.Field_Name}
              filterMatchMode="contains"
              filter={isSearch}
              filterPlaceholder={ele?.Field_Name}
              header={columnHeader(ele?.Field_Name, ele?.Field_Name, ele)}
              columnKey={ele?.Field_Name || i}
              frozen={frozenColumns.includes(ele.Field_Name)}
              body={rowData => {
                const rawCicStatusValue = rowData && rowData.data && typeof rowData.data[ele.Field_Name] !== 'undefined' 
                  ? rowData.data[ele.Field_Name] 
                  : '';
                // Ensure cicStatusValue is renderable - convert objects to strings
                const cicStatusValue = (typeof rawCicStatusValue === 'object' && rawCicStatusValue !== null) 
                  ? JSON.stringify(rawCicStatusValue) 
                  : (rawCicStatusValue ?? '');
                return (
                  <div>
                    {cicStatusValue}
                  </div>
                );
              }}
              className={
                 ele?.freeze
                  ? "fontBoldcolor"
                  : "cursorMove non-task-width"
              }
              showFilterMenu={false}
              style={{
                width:columnWidthKeys?.includes(ele?.Field_Name)&& columnWidth
                  && columnWidth[ele?.Field_Name],
                whiteSpace: chwrapFreeText ? 'normal' : 'nowrap',
                wordBreak: chwrapFreeText ? 'break-word': 'unset',
                overflow: chwrapFreeText ? 'unset' : 'hidden',
                textOverflow: chwrapFreeText ? 'unset' : 'ellipsis',
              }}
              headerClassName="bw-yellow-header"
            />
          );
        }
        if (ele?.Field_Name === "AWMCICStatus") {
          return (
            <Column
              key={ele?.Field_Name}
              field={ele?.Field_Name}
              filterField={ele?.Field_Name}
              filterMatchMode="contains"
              filter={isSearch}
              filterPlaceholder={ele?.Field_Name}
              header={columnHeader(ele?.Field_Name, ele?.Field_Name, ele)}
              columnKey={ele?.Field_Name || i}
              frozen={frozenColumns.includes(ele.Field_Name)}
              body={rowData => {
                const rawCicStatusValue = rowData && rowData.data && typeof rowData.data[ele.Field_Name] !== 'undefined' 
                  ? rowData.data[ele.Field_Name] 
                  : '';
                // Ensure cicStatusValue is renderable - convert objects to strings
                const cicStatusValue = (typeof rawCicStatusValue === 'object' && rawCicStatusValue !== null) 
                  ? JSON.stringify(rawCicStatusValue) 
                  : (rawCicStatusValue ?? '');
                  
                if (!cicStatusValue) {
                  return <span></span>;
                }
                
                // If value contains "|" (pipe character), show as text 
                if (cicStatusValue?.includes("|")) {
                  return <div className="status">{cicStatusValue}</div>;
                }
                
                // For all other values (including "NA"), show as icon with tooltip
                const tooltipText = cicOptions(cicStatusValue) || changeHandlingExportCSVFlags(cicStatusValue, false);
                
                // For "NA" values, show as text but still with tooltip
                if (cicStatusValue === "NA") {
                  return (
                    <div
                      className="cic-tooltip-target status"
                      title={tooltipText || `Status: ${cicStatusValue}`}
                      data-tooltip={tooltipText} // Additional data attribute for debugging
                    >
                      N/A
                    </div>
                  );
                }
                
                // For all other values, show as icon with tooltip
                return (
                  <div
                    className="cic-tooltip-target show-popup status cursor"
                    title={tooltipText || `Status: ${cicStatusValue}`}
                    data-tooltip={tooltipText}
                    onClick={() => {
                      setRowFullkitData(rowData.data);
                      setFieldName('cic');
                      setOpenFullkitPopUp(true);
                    }}
                  >
                    <div className="footerIconsMain">
                      <div>
                        <i className={`footerIconAll ${cicImage(cicStatusValue)}`}></i>
                      </div>
                    </div>
                  </div>
                );
              }}
              className={
               ele?.freeze
                  ? "fontBoldcolor"
                  : "cursorMove non-task-width"
              }
              showFilterMenu={false}
              style={{
                width:columnWidthKeys?.includes(ele?.Field_Name)&& columnWidth
                  && columnWidth[ele?.Field_Name],
                whiteSpace: chwrapFreeText ? 'normal' : 'nowrap',
                wordBreak: chwrapFreeText ? 'break-word': 'unset',
                overflow: chwrapFreeText ? 'unset' : 'hidden',
                textOverflow: chwrapFreeText ? 'unset' : 'ellipsis',
              }}
              headerClassName="awm_cic_status"
            />
          );
        }
        return (
          <Column
            key={ele?.Field_Name}
            field={ele?.Field_Name}
            filterField={ele?.Field_Name}
            filterMatchMode="contains"
            filter={isSearch}
            filterPlaceholder={ele?.Field_Name}
            header={columnHeader(ele?.Field_Name, ele?.Field_Name, ele)}
            columnKey={ele?.Field_Name || i}
            frozen={frozenColumns.includes(ele.Field_Name)}
            body={rowData => {
              if (!ele?.Field_Name || !rowData || !rowData.data || typeof rowData.data[ele.Field_Name] === 'undefined') {
                return <span></span>;
              }
              
              const fieldValue = rowData.data[ele.Field_Name];
              let displayValue = fieldValue;
              if (ele?.Field_Name === 'DateDetected' || ele?.Field_Name === 'DateCompleted') {
                displayValue = formatDateWithMonthName(fieldValue);
              }
              
              // Ensure displayValue is renderable - convert objects to strings
              const safeDisplayValue = (typeof displayValue === 'object' && displayValue !== null) 
                ? JSON.stringify(displayValue) 
                : (displayValue ?? '');
              
              return (
                (ele?.Field_Name === "BufferToWorkRatio") ? bufferToWork(safeDisplayValue)
                :
                (ele?.Field_Name === "IsPOAEditable") ? isPOAEditableColor(safeDisplayValue)
                :
                <span style={{ color: 'inherit' }}>
                  {safeDisplayValue}
                </span>
              );
            }}
            className={frozenColumns.includes(ele.Field_Name) ? "font-bold frozen-col-width" : ""}
            showFilterMenu={false}
            style={{
              width:columnWidthKeys?.includes(ele?.Field_Name)&& columnWidth
                && columnWidth[ele?.Field_Name],
                whiteSpace: chwrapFreeText ? 'normal' : 'nowrap',
                wordBreak: chwrapFreeText ? 'break-word': 'unset',
                overflow: chwrapFreeText ? 'unset' : 'hidden',
                textOverflow: chwrapFreeText ? 'unset' : 'ellipsis',
            }}
          />
        );
      })];
    }
    return <></>;
  };

  // The columnHeader function renders the column name and filter icon, and handles filter popup
  const columnHeader = (options, keyId, col) => {
    let sortDirection = null;
    if (sortData && sortData.length && sortData[0] === options) {
      sortDirection = sortData[1];
    }
    // Handler for filter icon click to open popup
    const handleFilterIconClick = (e) => {
      e.stopPropagation();
      setSelectedColumnName(options);
      setTimeout(() => {
        if (op.current) {
          op.current.toggle(e);
        }
      }, 0);
    };
    // Use Column_Name if present, else fallback to options (field_Name)
    const displayName = col && col.Column_Name ? col.Column_Name : options;
    return (
      <div 
        className={`flex-display ${frozenColumns.includes(col.Field_Name) ? "font-bold frozen-col-width" : ""}`} 
        key={keyId}
      > 
        <img
          src={
            selectedFields?.[options]?.[0] || selectedFields?.[options]?.[0] === false
              ? blueFilter
              : filter
          }
          alt="Column Filter"
          key={keyId}
          onClick={handleFilterIconClick}
          className="columnFilterIcon"
        />
        <span
          className="columnFilterIcon"
          style={{
            whiteSpace: chwrapFreeText ? 'normal' : 'nowrap',
            wordBreak: chwrapFreeText ? 'break-word': 'unset',
            overflow: chwrapFreeText ? 'unset' : 'hidden',
            textOverflow: chwrapFreeText ? 'unset' : 'ellipsis',
          }}
        >
          {displayName}
        </span>
      </div>
    );
  };

  const onClickClearFilter = () => {
    localStorage.removeItem("sortingDataChangeHandling");
    setGlobalFilterActivated(false);
    selectedColumnList.current = [];
    selectedFieldsRef.current = [];
    setFieldUpdated(!fieldUpdated);
    setSelectedFields({});
    setVisible(false);
    setFilters([]);
    setTableData(items);
    if (sortData?.length) {
      onSort(sortData[0], sortData[1], items);
    }
  };

  //Handler for Refresh POA button
  const handleRefreshPOA = async () => {
    const poaNumbers = [...new Set(tableData.map(items => items.data.RTA_POANumber))]
    if (!poaNumbers.length) {
      return;
    }
    setRefreshPOLoading(true);
    try {
      const result = await refreshPOA(poaNumbers);
      // Handle status codes 0 (success) and 1 (failure)
      if (result && result.success) {
        toast.current?.show({
          severity: 'success',
          summary: 'POA refreshed successfully!',
          detail: result.message || 'POA refreshed successfully!',
          life: 3000
        });
        await getChangeHandlingData();
        // Clear checkbox selections after successful refresh
        setCheckboxSelected([]);
      } else if (result && !result.success) {
        toast.current?.show({
          severity: 'error',
          summary: 'POA Refresh Failed',
          detail: result.message || 'Failed to refresh POA. Please try again.',
          life: 3000
        });
      } else {
        toast.current?.show({
          severity: 'error',
          summary: 'POA Refresh Failed',
          detail: 'Failed to refresh POA. Please try again.',
          life: 3000
        });
      }
    } catch (err) {
      toast.current?.show({
        severity: 'error',
        summary: 'POA Refresh Failed',
        detail: 'Failed to refresh POA. Please try again.',
        life: 3000
      });
    } finally {
      setRefreshPOLoading(false);
    }
  };

  // Column resize handler for DataTable
  const onColumnResizeEnd = (event) => {
    let columnWidth = {};
    let localColumnWidth = localStorage.getItem("columnWidthASAChangeHandling");
    if (localColumnWidth) {
      columnWidth = JSON.parse(localColumnWidth);
    }
    columnWidth[event.column.props.field] = event.element.offsetWidth;
    localStorage.setItem("columnWidthASAChangeHandling", JSON.stringify(columnWidth));
    setFieldUpdated(!fieldUpdated);
  };

  // Column reorder handler for DataTable
  const storeReorderedColumns = (e) => {
    if (!projectColumnName?.length) return;
    
    const reorderedColumns = [...projectColumnName];
    if (e?.dragIndex !== -1 && e?.dropIndex !== -1) {
      const [removed] = reorderedColumns.splice(e.dragIndex, 1);
      reorderedColumns.splice(e.dropIndex, 0, removed);
    }
    
    // Update the column order in localStorage
    const customizeViewData = getCustomizeViewLocalStorage();
    if (customizeViewData) {
      const updatedCustomizeView = {
        ...customizeViewData,
        selectedFields: {
          ...customizeViewData.selectedFields,
          fieldsData: reorderedColumns
        }
      };
      localStorage.setItem("customizeViewFieldsChangeHandling", JSON.stringify(updatedCustomizeView));
    }
    
    setProjectColumnNames(reorderedColumns);
    setResetKey(prev => prev + 1);
  };

  //update state value
  const updateStateValue = (key, val) => {
    setState((prev) => ({ ...prev, [key]: val }));
  };
  /*code for customize feild*/
  const formCustomizeObject = (availableFields, freezedColumns, selectedFeilds) => {
    const customizeViewFieldsUpdated = {
      availableFields: {
        id: "availableFields",
        title: "Available Fields",
        fieldsData: availableFields,
      },
      freezedColumns: {
        id: "freezedColumns",
        title: "Freezed Fields",
        fieldsData: freezedColumns,
      },
      selectedFields: {
        id: "selectedFields",
        title: "Selected Fields",
        fieldsData: selectedFeilds,
      },
    };

    return customizeViewFieldsUpdated;
  };

  const getAvailableFields = (customizeViewFields) => {
    const availableData = customizeViewFields?.availableFields?.fieldsData;
    let availableDataList = [];
    if (availableData?.length > 0) {
      availableData.map((item) => {
        const innerObj = {
          Field_Name: item,
        };
        availableDataList.push(innerObj);
      });
      setAvailableFields(availableDataList);
    }
  };

  const clearFiltersResetToPG = async () => {
    setLoader(true)
    localStorage.setItem("customizeViewFieldsChangeHandling", JSON.stringify({}));
    await setColumnsOrder(userInformation?.userid, "customizeViewFieldsChangeHandling", "NA","NA",true, "");
    await setColumnsOrder(userInformation?.userid, "ChangeHandlingAllColumnNames","NA","NA", true, "");
    setProjectColumnNames(Object.keys(showTableColumns));
    await setToInitialCustomizeView()
    setFrozenColumn([]);
    isCustomViewIsAddedMyProject(false)
    setResetKey((prev) => prev+1);
    setLoader(false)
  }

  const handleCustomizedView = async (data) => {
    if (data !== undefined && data !== null && data?.length !== 0) {
      const parsedData = data?.selectedFields?.fieldsData?.length
        ? data
        : data && JSON.parse(data);
      const freezedData = parsedData?.freezedColumns?.fieldsData || [];
      let selectedData = parsedData?.selectedFields?.fieldsData || [];
      localStorage.setItem("customizeViewFieldsChangeHandling", JSON.stringify(parsedData));
      await setColumnsOrder(
        userInformation?.userid,
        "customizeViewFieldsChangeHandling",
        "NA",
        "NA",
        false,
        JSON.stringify(parsedData)
      );
      // Do NOT remove frozen columns from selectedData; show both
      const allTableColumns = Array.isArray(freezedData)
        ? [...freezedData, ...selectedData.filter(col => !freezedData.includes(col))]
        : selectedData;
      if (!checkIfOrderSame(ProjectService.getASAChangeHandlingTableColumns(), allTableColumns)) {
        isCustomViewIsAddedMyProject(true);
      } else {
        isCustomViewIsAddedMyProject(false);
      } //enable reset button if selected feilds order has changed
      setProjectColumnNames(allTableColumns);
      setCustomizeViewFields(parsedData);
      getAvailableFields(parsedData);
      // Always update frozenColumns state to match customize view
      setFrozenColumn(Array.isArray(freezedData) ? [...freezedData] : []);

      // Update tableData to reflect new columns
      setTableData((prevData) => {
        if (!Array.isArray(items)) return [];
        // Only keep fields in allTableColumns (frozen + selected)
        return items.map(row => {
          if (!row || !row.data) return row;
          const filtered = {};
          allTableColumns.forEach(col => {
            filtered[col] = row.data[col];
          });
          return { ...row, data: filtered };
        });
      });
    }
  };

  const onGlobalFilterChange = (e, colName) => {
    // Use multiFilterChange utility as in ArtworkAlignmentPage
    const { value, multiplesFlag, arr } = multiFilterChange(
      { value: e }, // e is already an array of primitives from the popup
      colName,
      selectedColumnName,
      selectedFields,
      setSelectedFields,
      items.map(row => row.data), // tableData equivalent
      filterArray,
      selectedColumnList,
      colAllSelected,
      selectedFieldsRef
    );
    // Update selectedFieldsRef as in ArtworkAlignment
    const _selectedFieldsRef = (selectedFieldsRef?.current || []).map((el, i) => {
      if (Object.keys(arr)?.[0] === Object.keys(el)?.[0]) {
        return {
          ...el,
          [`${selectedColumnName}`]: arr[selectedColumnName],
        };
      } else {
        return el;
      }
    });
    if (AcpService.areAllPropertiesEmptyArrays(_selectedFieldsRef)) {
      localStorage.removeItem("_selectedFieldsRefCurrentChangeHandling");
    }
    if (filterArray.current?.length) {
      if ((value?.length > 0 && !multiplesFlag) || colAllSelected.current?.length >= 1) {
        const _selectedFieldsRefWithoutEmptyArray = AcpService.removeEmptyArrays(_selectedFieldsRef);
        const _selectedFieldsRefWithUniqueObjects = AcpService.getUniqueObjects(_selectedFieldsRefWithoutEmptyArray);
        const filterData = AcpService.filterDataByfilters(
          items.map(row => row.data),
          _selectedFieldsRefWithUniqueObjects,
          setConditionMatched,
          "ChangeHandling"
        );
        // Always wrap filtered data for the table
        const wrappedFilterData = Array.isArray(filterData)
          ? filterData.map(row => ({ data: row }))
          : [];
        const convertedObj = AcpCommonService.convertArrayToObject(_selectedFieldsRefWithoutEmptyArray);
        const uniqueObj = AcpCommonService.getUniqueValuesObject(convertedObj);
        setSelectedFields(uniqueObj);
        if (wrappedFilterData?.length && sortData?.length) {
          onSort(sortData[0], sortData[1], wrappedFilterData);
        } else {
          setFilters(wrappedFilterData);
          setTableData(wrappedFilterData);
          selectedColumnList.current = wrappedFilterData;
        }
      } else {
        setFilters(items);
        setTableData(items);
        selectedColumnList.current = [];
        selectedFieldsRef.current = [];
        setSelectedFields({});
      }
    } else {
      setFilters(items);
      setTableData(items);
      selectedColumnList.current = [];
      selectedFieldsRef.current = [];
      setSelectedFields({});
    }
  };

  const clearColumnWiseFilter = () => {
    let _selectedColumnName = selectedColumnName;
    if (sortData && sortData?.length && sortData[0] === _selectedColumnName) {
      localStorage.removeItem("sortingDataChangeHandling");
      setSortData([]);
    }

    const selectedFields2 = _.cloneDeep(selectedFields);
    const uniqueObj = AcpCommonService.getUniqueValuesObject(selectedFields2);
    const _selectedFields = AcpService.emptyProperty(uniqueObj, _selectedColumnName);
    const __selectedFields = AcpCommonService.removeEmptyArraysWithNoData(_selectedFields);
    selectedFieldsRef.current = __selectedFields;
    setSelectedFields(__selectedFields);
    if (AcpService.areAllPropertiesEmptyArrays(__selectedFields)) {
      localStorage.removeItem("_selectedFieldsRefCurrentChangeHandling");
    }
    if (Object.entries(__selectedFields)?.length) {
      setGlobalFilterActivated(true);
    } else {
      setGlobalFilterActivated(false);
    }
    let { Task, ...newObj } = __selectedFields;
    let filteredData2 = [];
    let filteredData = [];
 
    const finalFilteredData = filteredData2?.length ? filteredData2 : filteredData;
    if (finalFilteredData?.length && Object.keys(__selectedFields)?.length) {
      setFilters(finalFilteredData);
    } else {
      setFilters([]);
      setGlobalFilterActivated(false);
    }
  };

  const clearHistoryColumnWiseFilter = () => {
    let _selectedColumnName = historySelectedColumn;
    if (sortHistoryData && sortHistoryData?.length && sortHistoryData[0] === _selectedColumnName) {
      setSortHistoryData([]);
    }

    const selectedFields2 = _.cloneDeep(historyFilters);
    const uniqueObj = AcpCommonService.getUniqueValuesObject(selectedFields2);
    const _selectedFields = AcpService.emptyProperty(uniqueObj, _selectedColumnName);
    const __selectedFields = AcpCommonService.removeEmptyArraysWithNoData(_selectedFields);
    setHistoryFilters(__selectedFields);
    setFilteredHistoryData(historyData);
  };

  const onSort = (column, direction, filterData) => {
    // Always sort the currently visible tableData (the rendered rows)
    let dataToSort = Array.isArray(tableData) && tableData.length ? tableData : items;
    // If a new filtered dataset is explicitly provided (e.g., after filter change), use it
    if (Array.isArray(filterData) && filterData.length) {
      dataToSort = filterData;
    }
    let sortedDataSet = [];
    if (column === "Task") {
      sortedDataSet = SortAndFilterService.sortMultiLabelData(dataToSort, column, direction);
    } else if (column === "DSBP_InitiativeID") {
      // Custom sort for DSBP_InitiativeID
      sortedDataSet = [...dataToSort].sort((a, b) => {
        const aVal = a.data?.DSBP_InitiativeID;
        const bVal = b.data?.DSBP_InitiativeID;
        if (aVal == null && bVal == null) return 0;
        if (aVal == null) return 1;
        if (bVal == null) return -1;
        if (!isNaN(Number(aVal)) && !isNaN(Number(bVal))) {
          return direction === "asc"
            ? Number(aVal) - Number(bVal)
            : Number(bVal) - Number(aVal);
        }
        return direction === "asc"
          ? String(aVal).localeCompare(String(bVal))
          : String(bVal).localeCompare(String(aVal));
      });
    } else {
      sortedDataSet = SortAndFilterService.sortMultiColumnData(dataToSort, column, direction);
    }
    setSortData([column, direction]);
    localStorage.setItem("sortingDataChangeHandling", JSON.stringify(true));
    setTableData(sortedDataSet); // Always update tableData for rendering
    setFilters(sortedDataSet);   // Keep filters in sync for UI highlights
    selectedColumnList.current = sortedDataSet;
  };

  const onSortHistory = (column, direction, filterData) => {
    // Always sort the currently visible tableData (the rendered rows)
    let dataToSort = Array.isArray(historyData) && historyData.length ? historyData : items;
    // If a new filtered dataset is explicitly provided (e.g., after filter change), use it
    if (Array.isArray(filterData) && filterData.length) {
      dataToSort = filterData;
    }
    let sortedDataSet = [];
    sortedDataSet = SortAndFilterService.sortMultiColumnData(dataToSort, column, direction);
    setSortHistoryData([column, direction]);
    setFilteredHistoryData(sortedDataSet);   // Keep filters in sync for UI highlights
    selectedColumnList.current = sortedDataSet;
  };

  // --- Handler for Historical Data (POST) ---
  const handleGetHistoryData = async () => {
    setHistoryLoading(true);
    try {
      const result = await getHistoryData(userAccessPayLoad);
      setHistoryData(result.PMPAttributeList.map(row => ({ data: row })));
      setShowHistoryDialog(true);
    } catch (err) {
      setHistoryData([]);
      setShowHistoryDialog(true);
    } finally {
      setHistoryLoading(false);
    }
  };
  // --- Handler for History Table Filter Icon Click ---
  const handleHistoryFilterIconClick = (e, colName) => {
    e.stopPropagation();
    setHistorySelectedColumn(colName);
    setTimeout(() => {
      if (historyOp.current) {
        historyOp.current.toggle(e);
      }
    }, 0);
  };

  // --- Handler for History Table Filter Change ---
  const onHistoryFilterChange = (e, colName) => {
    const values = e.value;
    const newFilters = { ...historyFilters, [colName]: values };
    setHistoryFilters(newFilters);
    let filtered = historyData;
    Object.entries(newFilters).forEach(([col, vals]) => {
      if (Array.isArray(vals) && vals.length > 0) {
        filtered = filtered.filter(row => vals.includes(row[col] ?? (row.data && row.data[col])));
      }
    });
    setFilteredHistoryData(filtered);
  };

  // Clear all history filters
  const clearHistoryFilters = () => {
    setHistoryFilters({});
    setFilteredHistoryData(historyData);
  };

  useEffect(() => {
    setFilteredHistoryData(historyData);
  }, [historyData]);

  // --- History Table Column Header with Filter Icon ---
  const historyColumnHeader = (colName) => {
    // Use the same display name logic as main table
    const columnInfo = allColumnsData?.find(col => col.Field_Name === colName);
    const displayName = columnInfo && columnInfo.Column_Name ? columnInfo.Column_Name : colName;
    return (
      <div className="flex-display" key={colName}>
        <img
          src={historyFilters[colName]?.length ? blueFilter : filter}
          alt="Column Filter"
          onClick={e => handleHistoryFilterIconClick(e, colName)}
          className="columnFilterIcon"
        />
        <span
          className="columnFilterIcon"
          style={{
            whiteSpace: historywrapFreeText ? 'normal' : 'nowrap',
            wordBreak: historywrapFreeText ? 'break-word': 'unset',
            overflow: historywrapFreeText ? 'unset' : 'hidden',
            textOverflow: historywrapFreeText ? 'unset' : 'ellipsis',
          }}
        >
          {displayName}
        </span>
      </div>
    );
  };

  // --- Columns for Historical Data Table ---
  const historyColumns = () => {
    let firstRow = {};
    if (Array.isArray(filteredHistoryData) && filteredHistoryData.length > 0) {
      firstRow = filteredHistoryData[0]?.data && typeof filteredHistoryData[0].data === 'object'
        ? filteredHistoryData[0].data
        : filteredHistoryData[0];
    }
    
    // Only show columns that exist in the main table and are available in historical data
    const availableKeys = Object.keys(firstRow || {});
    const colNames = projectColumnName?.length > 0 
      ? projectColumnName.filter(colName => availableKeys.includes(colName))
      : availableKeys;
    
    
    let columnWidths = {};
    try {
      const storedWidths = localStorage.getItem('columnWidthASAChangeHandling');
      if (storedWidths) {
        columnWidths = JSON.parse(storedWidths);
      }
    } catch (e) { columnWidths = {}; }
    return colNames.map((colName, i) => {
      // Get unique options for this column
      const options = Array.from(new Set(historyData.map(row => row[colName] ?? (row.data && row.data[colName])).filter(v => v !== undefined && v !== null && v !== "")));
      const multiSelectOptions = options.map(opt => ({ label: String(opt), value: opt }));
      // Use the same width as the main table column
      let width = columnWidths && columnWidths[colName] ? columnWidths[colName] : undefined;
      // Fallback: if Task column, use 280px, else 150px
      if (!width) { width = colName === 'Task' ? 280 : 120; }
      return (
        <Column
          key={colName}
          field={colName}
          header={historyColumnHeader(colName)}
          filter={isHistorySearch}
          filterElement={isHistorySearch ? (
            <input
              type="text"
              value={historyFilters[colName] || ''}
              onChange={e => {
                const value = e.target.value;
                const newFilters = { ...historyFilters, [colName]: value };
                setHistoryFilters(newFilters);
                // Filter logic: match substring (case-insensitive)
                let filtered = historyData;
                Object.entries(newFilters).forEach(([col, val]) => {
                  if (val && val.length > 0) {
                    filtered = filtered.filter(row => {
                      const dataObj = row?.data && typeof row.data === 'object' ? row.data : row;
                      return String(dataObj[col] ?? '').toLowerCase().includes(val.toLowerCase());
                    });
                  }
                });
                setFilteredHistoryData(filtered);
              }}
              placeholder={`${fieldDisplayNames[colName] || colName}`}
              className="dsbp-history-filter-input"
              style={{ width: '100%' }}
            />
          ) : null}
          body={rowData => {
            // Defensive: support both { data: ... } and plain objects
            const dataObj = rowData?.data && typeof rowData.data === 'object' ? rowData.data : rowData;
            let value = dataObj && typeof dataObj[colName] !== 'undefined' ? dataObj[colName] : '';
            
            // Special handling for AWMCICStatus column - show icons like main table
            if (colName === 'AWMCICStatus') {
              const rawCicStatusValue = value;
              // Ensure cicStatusValue is renderable - convert objects to strings
              const cicStatusValue = (typeof rawCicStatusValue === 'object' && rawCicStatusValue !== null) 
                ? JSON.stringify(rawCicStatusValue) 
                : (rawCicStatusValue ?? '');
                
              if (!cicStatusValue) {
                return <span></span>;
              }
              
              // If value contains "|" (pipe character), show as text 
              if (cicStatusValue?.includes("|")) {
                return <div className="status">{cicStatusValue}</div>;
              }
              
              // For all other values (including "NA"), show as icon with tooltip
              const tooltipText = cicOptions(cicStatusValue) || changeHandlingExportCSVFlags(cicStatusValue, false);
              
              // For "NA" values, show as text but still with tooltip
              if (cicStatusValue === "NA") {
                return (
                  <div
                    className="cic-tooltip-target status"
                    title={tooltipText || `Status: ${cicStatusValue}`}
                    data-tooltip={tooltipText}
                  >
                    N/A
                  </div>
                );
              }
              
              // For all other values, show as icon with tooltip and click handler
              return (
                <div
                  className="cic-tooltip-target show-popup status cursor"
                  title={tooltipText || `Status: ${cicStatusValue}`}
                  data-tooltip={tooltipText}
                  onClick={() => {
                    setRowFullkitData(dataObj);
                    setFieldName('cic');
                    setOpenFullkitPopUp(true);
                  }}
                >
                  <div className="footerIconsMain">
                    <div>
                      <i className={`footerIconAll ${cicImage(cicStatusValue)}`}></i>
                    </div>
                  </div>
                </div>
              );
            }
            
            // Format date fields with month names and dashes
            if ((colName === 'DateDetected' || colName === 'DateCompleted') && value) {
              value = formatDateWithMonthName(value);
            }
            
            // Ensure value is renderable - convert objects to strings
            const safeValue = (typeof value === 'object' && value !== null) 
              ? JSON.stringify(value) 
              : (value ?? '');
            
            return (
              <span
                style={{
                  whiteSpace: historywrapFreeText ? 'normal' : 'nowrap',
                  wordBreak: historywrapFreeText ? 'break-word' : 'unset',
                  overflow: historywrapFreeText ? 'unset' : 'hidden',
                  textOverflow: historywrapFreeText ? 'unset' : 'ellipsis',
                  display: 'block',
                }}
              >
                {safeValue}
              </span>
            );
          }}
          style={{
            width,
            minWidth: width,
            maxWidth: width,
            whiteSpace: historywrapFreeText ? 'normal' : 'nowrap',
            wordBreak: historywrapFreeText ? 'break-word' : 'unset',
            overflow: historywrapFreeText ? 'unset' : 'hidden',
            textOverflow: historywrapFreeText ? 'unset' : 'ellipsis',
          }}
        />
      );
    });
  };

  // Helper to get dynamic values for history payload
  const getHistoryPayload = (row, attribute) => { 
    const selectedRow = row && row.data ? row.data : row;
    const payload = {
      ...userAccessPayLoad,
      ArtworkAgilityPMPs: [
        {
          DSBP_PMP_PIMaterialID: selectedRow.DSBP_PMP_PIMaterialID || '',
          Attribute: selectedRow.Field || attribute || '',
        },
      ],
    };
    return payload;
  };

  const setConditionMatched = () => {};
  const handlePageEdited = () => {};
  const markClean = () => {};

  // Handler for back navigation in footer
  const handleBack = () => {
    if (pageEdited) {
      handlePageEdited("handleBack");
    } else { 
      markClean();
      setPageEdited(false);
      safeNavigate(projectPlanUrl);
    }
  };

  // Handler for canceling navigation in UnsavedChangesDialog
  const cancelNavigation = () => {
    setShowDialog(false);
  };
  // Handler for confirming navigation in UnsavedChangesDialog
  const confirmNavigation = () => {
    markClean();
    setShowDialog(false);
    setPageEdited(false);
    safeNavigate(projectPlanUrl);
  };

  // Define exportHeaders based on currently visible columns
  const exportHeaders = Array.isArray(allSelectedColumns)
    ? allSelectedColumns.map(col => ({
        label: col.Column_Name ? col.Column_Name : col.field_Name,
        key: col.field_Name
      }))
    : [];

  // --- History Export Headers ---
  const historyExportHeaders = (() => {
    let firstRow = {};
    if (Array.isArray(filteredHistoryData) && filteredHistoryData.length > 0) {
      firstRow = filteredHistoryData[0]?.data && typeof filteredHistoryData[0].data === 'object'
        ? filteredHistoryData[0].data
        : filteredHistoryData[0];
    }
    return Object.keys(firstRow || {}).map(col => ({ label: col, key: col }));
  })();
  const handleConfirmation = () => {
    setShowConfirmationPopUp(true);

    const filteredData = items
      ?.filter((ele) => checkboxSelected.includes(ele?.data?.ID))
      .map((ele) => ({
        DSBP_InitiativeID: ele.data.DSBP_InitiativeID,
        DSBP_PMP_PIMaterialID: ele.data.DSBP_PMP_PIMaterialID,
        DSBP_PMP_PIMaterialNumber: ele.data.DSBP_PMP_PIMaterialNumber,
        Attribute: ele.data.Field,
        OldValue: ele.data.OldValue,
        NewValue: ele.data.NewValue,
        POANumber: ele.data.RTA_POANumber,
        ImpactingPOA: ele.data.ImpactingPOA,
      }));

    setShowConfirmationPopUpData(filteredData);
  };

  const handleConfirmationClose = () => {
    setShowConfirmationPopUp(false)
    setShowConfirmationPopUpData([])
  }

  // Handler for confirmation success - refresh data and clear checkboxes
  const handleConfirmationSuccess = async () => {
    await getChangeHandlingData();
    // Clear checkbox selections after successful confirmation
    setCheckboxSelected([]);
  };

 const getColumnName = (fieldName) => {
    if(allColumnsData) {
      return allColumnsData.find(item => (item.Field_Name === fieldName)).Column_Name
    }
  }

  const getUpdatedAllColumnFormat = (column) => {
    const finalData = column.map((el) => {
      return {
        width: 250,
        Sequence: "",
        freeze: false,
        Field_Name: el,
        reorder: false,
        Column_Name: getColumnName(el),
        sortAtoZ: false,
        sortZtoA: false,
        Attribute_Type: "Free Text",
      };
    });
    return finalData;
  };


  // Helper function to get change handling status for FullKit popup
  const getChangeHandlingStatus = () => {
    if (!rowFullkitData) return null;
    const resObj = AcpService.getBURegion(UserGroup);
    return {
      BU: resObj?.bu || "",
      Region: resObj?.region || ""
    };
  };

  // FooterComponent to display record counts similar to ArtworkAlignment
  const FooterComponent = () => (
    <Footer
      className="footer"
      selected={checkboxSelected}
      totalObjects={Array.isArray(tableData) ? tableData.length : 0}
      isSelected={true}
    />
  );

  return (
    <PageLayout>
      {(loader || historyLoading || refreshPOLoading) ? (
           <LoadingOverlay className="h-100" active={loader || historyLoading || refreshPOLoading} spinner text=""/>
          ) : 
      checkReadWriteAccess ?
      <div className="changeHandling-wrapper">
        <CustomizeView
          setLoader={setLoader}
          availableFields={availableFields || []}
          headerName="Change Handling"
          showTaskDialog={visible}
          onClose={() => setVisible(false)}
          customizeViewFields={customizeViewFields}
          setCustomizeViewFields={handleCustomizedView}
          resetToPgDefault={clearFiltersResetToPG}
          allColumns={getUpdatedAllColumnFormat(allColumnNames)}
          pgDefaultColumns={pgDefaultColumns}
          setResetKey={setResetKey}
        />
        <ChangeHandlingHeader
          headers={exportHeaders}
          filename={`ChangeHandling_Records`}
          selectedRows={filters?.length ? filters.map(row => row.data) : []}
          onSearchClick={onSearchClick}
          allData={items.map(row => row.data)}
          clearFilter={onClickClearFilter}
          setVisible={() => setVisible(true)}
          onChildClick={handleChildClick}
          isFilterEnabled={isSearch || filters?.length > 0}
          chwrapFreeText={chwrapFreeText}
          setchWrapFreeText={setchWrapFreeText}
          onRefreshPOA={handleRefreshPOA}
          refreshPOLoading={refreshPOLoading}
          onGetHistoryData={handleGetHistoryData}
          historyLoading={historyLoading}
          checkboxSelected={checkboxSelected}
          navigationState={navigationState}
          onShowAllClick={handleShowAll}
        />
        {/* Move LoadingOverlay below header and above table so header buttons are always clickable */}
        <div className="changeHandling myProjectAnddAllProjectList">
          <div className="card">
            {loader && (
              <div className="loader">
                <span className="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>
              </div>
            )}
            
            {items && items.length ? (
              <>
                {/* <ACPFilter
                  op={op}
                  onSort={onSort}
                  pageName={"Change Handling"}
                  sortData={sortData}
                  pegadata={pegadata}
                  setSortData={setSortData}
                  projectData={items.map(row => row.data)}
                  generateCustomOptions={true}
                  selectedFields={selectedFields}
                  selectAllColumnNotIncluded={true}
                  frozenColumns={frozenColumns}
                  selectedColumnName={selectedColumnName}
                  onGlobalFilterChange={onGlobalFilterChange}
                  clearColumnWiseFilter={clearColumnWiseFilter}
                  setSelectedColumnName={setSelectedColumnName}
                /> */}
                <DataTable
                  emptyMessage={loader ? " " : "Currently, there are no changes to display"}
                  value={Array.isArray(tableData) ? tableData : []}
                  resizableColumns
                  reorderableColumns
                  onColumnResizeEnd={onColumnResizeEnd}
                  onColReorder={storeReorderedColumns}
                  className={isSearch ? "searchWithDataTable" : ""}
                  rowClassName={(rowData) => checkboxSelected.includes(rowData[0]?.data?.ID) ? "selected-row" : ""}
                  filterDisplay={isSearch && "row"}
                  responsiveLayout="scroll"
                  columnResizeMode="expand"
                  scrollable
                  // scrollHeight={state.tableHeight}
                  showGridlines
                  stripedRows
                  size="small"
                  tableStyle={{
                    width: "max-content",
                    minWidth: "100%",
                  }}
                  frozenWidth={frozenWidth}
                  key={resetKey}
                >
                  {dynamicColumns()}
                </DataTable>
              </>
            ) : (
              "Currently, there are no changes to display"
            )}
          </div>
        

          <Dialog
            visible={showHistoryDialog}
            onHide={() => {
              setShowHistoryDialog(false)
              clearHistoryFilters()
            }}
            header={<ChangeHandlingHistoryHeader
              headers={historyExportHeaders}
              filename={'ChangeHandling_History'}
              selectedRows={filteredHistoryData}
              onSearchClick={onHistorySearchClick}
              allData={historyData}
              clearFilter={clearHistoryFilters}
              setVisible={() => setVisible(true)}
              onChildClick={handleChildClick}
              isFilterEnabled={Object.values(historyFilters).some(val => val && val.length > 0) || isHistorySearch}
              historywrapFreeText={historywrapFreeText}
              setHistoryWrapFreeText={setHistoryWrapFreeText}
              onRefreshPOA={handleRefreshPOA}
              refreshPOLoading={refreshPOLoading}
            />}
            className="p-dialog-custom history-dialog"
          >
            
            {historyLoading ? (
              <div historyLoader>
                <span className="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>
                <div>Loading...</div>
              </div>
            ) : Array.isArray(filteredHistoryData) && filteredHistoryData.length > 0 && Object.keys((filteredHistoryData[0]?.data && typeof filteredHistoryData[0].data === 'object' ? filteredHistoryData[0].data : filteredHistoryData[0]) || {}).length > 0 ? (
              <div className="historyTable">
               
                  {/* --- Remove the acp-filters filter row above the table --- */}
                  <DataTable
                    emptyMessage="No historical records found"
                    value={Array.isArray(filteredHistoryData) ? filteredHistoryData : []}
                    resizableColumns
                    reorderableColumns
                    className='historyDataTable mt-3'
                    filterDisplay={isHistorySearch && "row"}
                    responsiveLayout="scroll"
                    columnResizeMode="expand"
                    scrollable
                    showGridlines
                    stripedRows
                    size="small"
                    tableStyle={{
                      width: "max-content",
                      minWidth: "100%",
                      maxHeight: "500px"
                    }}
                  >
                    {historyColumns()}
                  </DataTable>
                  {/* Unified filter popup for history table */}
                  <ChangeHandlingHistoryFilter
                    historyOp={historyOp}
                    onSort={onSortHistory}
                    selectedColumnName={historySelectedColumn}
                    setSelectedColumnName={setHistorySelectedColumn}
                    tableData={historyData}
                    selectedFields={historyFilters}
                    onGlobalFilterChange={onHistoryFilterChange}
                    setFieldUpdated={setFieldUpdated}
                    fieldUpdated={fieldUpdated}
                    clearColumnWiseFilter={clearHistoryColumnWiseFilter}
                    sortData={sortHistoryData}
                  />
                
              </div>
            ) : (
              <div className='HistoryData'>
                <div className="noDataFound">No historical data found</div>
              </div>
            )}
          </Dialog>
        </div>
      <UnsavedChangesDialog
        visible={showDialog}
        onCancel={cancelNavigation}
        onConfirm={confirmNavigation}
      />
      {/* <ChangeHandlingFilter
        op={op}
        onSort={onSort}
        selectedColumnName={selectedColumnName}
        tableData={items}
        selectedFields={selectedFields}
        onGlobalFilterChange={onGlobalFilterChange}
        setFieldUpdated={setFieldUpdated}
        fieldUpdated={fieldUpdated}
        clearColumnWiseFilter={clearColumnWiseFilter}
        sortData={sortData}
      /> */}
      <div className="table-footer">
        <TableFooter isSpecialProject={isSpecialProject} />
      </div>
      <FooterButtons
        accessType={accessType}
        handleCancel={handleBack}
        hideSaveButton={true}
        onSubmit={handleConfirmation}
        formValid={checkboxSelected.length === 0}
        checkReadWriteAccess={checkReadWriteAccess}
        submitAndSave="Confirm"
        FooterComponent={!loader && tableData && FooterComponent}
        isCancelDisabled={false}
        cancelButtonText="Back"
      />
      </div>:  <UnAuthorizedComponent nowrapper={true} />}
      {/* Using to Show the warning */}
      <UnsavedChangesDialog
        visible={showDialog}
        onCancel={cancelNavigation}
        onConfirm={confirmNavigation}
      />
      <ChangeHandlingFilter
        op={op}
        onSort={onSort}
        selectedColumnName={selectedColumnName}
        setSelectedColumnName={setSelectedColumnName}
        tableData={items}
        selectedFields={selectedFields}
        onGlobalFilterChange={onGlobalFilterChange}
        setFieldUpdated={setFieldUpdated}
        fieldUpdated={fieldUpdated}
        clearColumnWiseFilter={clearColumnWiseFilter}
        sortData={sortData}
      />
      <ConfirmationPopUp
        data={confirmationPopUpData}
        visible={showConfirmationPopUp}
        onCancel={handleConfirmationClose}
        onSuccess={handleConfirmationSuccess}
      />
      <Suspense fallback={<div></div>}>
        <FullKitConditionPopUp
          key={`${rowFullkitData?.ID}-${fieldName}`}
          openFullKitpopUp={openFullKitpopUp}
          setOpenFullkitPopUp={setOpenFullkitPopUp}
          rowFullkitData={rowFullkitData}
          setRowFullkitData={setRowFullkitData}
          fieldName={fieldName}
          changeHandlingStatus={getChangeHandlingStatus()}
        />
      </Suspense>
      <Toast ref={toast} />
    </PageLayout>
  );
}

export default ChangeHandlingWrapper;